import { sanitize } from './sanitize';

const ensureDataLayer = () => {
  if (!Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }
  return window.dataLayer;
};

export const getDataLayer = () => ({
  push: (event) => {
    const sanitised = sanitize(event);
    if (sanitised === null) return;
    ensureDataLayer().push(sanitised);
  }
});
